var _rect, _rect2, _g, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingcard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.913086,
    y: 0.70459,
    width: 49.7762,
    height: 49.7776,
    rx: 24.8881,
    fill: "url(#paint0_radial_136_1839)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.35753,
    y: 1.14903,
    width: 48.8873,
    height: 48.8887,
    rx: 24.4437,
    stroke: "#006EC2",
    strokeOpacity: 0.1,
    strokeWidth: 0.888889
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_1839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5903 25.8125C25.585 25.8509 24.8221 31.3072 22.5806 34.2119C22.4198 34.4619 22.2309 34.7012 22.0142 34.9238C20.4079 36.5733 17.8773 36.7146 16.3628 35.2402C14.8486 33.7655 14.9236 31.2327 16.5298 29.583C16.8942 29.2088 17.3068 28.9131 17.7437 28.6953C20.6822 26.6319 25.5789 25.8144 25.5903 25.8125ZM25.9722 25.8174C26.0137 25.8232 30.9097 26.5111 33.8931 28.4893C34.3356 28.6953 34.7561 28.9794 35.1304 29.3438C36.7801 30.95 36.9222 33.4805 35.4478 34.9951C33.973 36.5093 31.4402 36.4353 29.7905 34.8291C29.5679 34.6124 29.373 34.3784 29.2056 34.1328C26.8877 31.2898 25.979 25.8583 25.9722 25.8174ZM29.5522 16.2627C31.1586 14.6131 33.6891 14.4717 35.2036 15.9463C36.7179 17.421 36.6429 19.9538 35.0366 21.6035C34.8176 21.8284 34.5809 22.0248 34.3325 22.1934C31.4943 24.5014 26.0921 25.4108 26.0259 25.4219C26.0308 25.3869 26.7173 20.4864 28.6968 17.501C28.9029 17.0582 29.1876 16.6372 29.5522 16.2627ZM16.1548 16.2236C17.6295 14.7096 20.1613 14.7837 21.811 16.3896C22.0364 16.609 22.234 16.8458 22.4028 17.0947C24.7123 19.9358 25.6209 25.3448 25.6304 25.4014C25.6304 25.4014 20.7036 24.7166 17.7075 22.7295C17.2653 22.5235 16.8452 22.2382 16.4712 21.874C14.8217 20.2677 14.6803 17.7382 16.1548 16.2236Z",
    fill: "url(#paint1_radial_136_1839)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7868,
    cy: 25.6135,
    rx: 0.239228,
    ry: 6.04906,
    fill: "url(#paint2_radial_136_1839)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7527,
    cy: 25.6133,
    rx: 0.239228,
    ry: 6.04906,
    transform: "rotate(-90 25.7527 25.6133)",
    fill: "url(#paint3_radial_136_1839)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_1839",
    x: 9.80192,
    y: 13.149,
    width: 31.9985,
    height: 31.9997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.55556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_1839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_1839",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_136_1839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8012 39.3711) rotate(90) scale(29.3332 29.3324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3998E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_136_1839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8011 25.5933) rotate(90) scale(35.774 35.7717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5D6FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_136_1839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7868 25.6135) rotate(90) scale(6.04906 0.239228)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_136_1839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7527 25.6133) rotate(90) scale(6.04906 0.239228)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingcard3);
export default __webpack_public_path__ + "static/media/pricingcard3.9f992ea9e7dc9091ecbcff89a6cb9697.svg";
export { ForwardRef as ReactComponent };